module.exports = __webpack_public_path__ + "img/voice.58736a7c.png";